import(/* webpackMode: "eager" */ "/home/node/build/src/app/error.tsx");
